'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _STARTER, _PROFESSIONAL, _ENTERPRISE, _STARTER$PROFESSIONAL;

var _Editions = require('self-service-api/constants/Editions');

var _Hubs = require('self-service-api/constants/Hubs');

var Hubs = _interopRequireWildcard(_Hubs);

var _MerchandiseIds = require('self-service-api/constants/MerchandiseIds');

var MerchandiseIds = _interopRequireWildcard(_MerchandiseIds);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = (_STARTER$PROFESSIONAL = {}, _defineProperty(_STARTER$PROFESSIONAL, _Editions.STARTER, (_STARTER = {}, _defineProperty(_STARTER, Hubs.HUB_MARKETING, MerchandiseIds.PRODUCT_MARKETING_STARTER_EMAIL), _defineProperty(_STARTER, Hubs.HUB_SALES, MerchandiseIds.PRODUCT_SALES_STARTER), _defineProperty(_STARTER, Hubs.HUB_SERVICE, MerchandiseIds.PRODUCT_SERVICE_STARTER), _STARTER)), _defineProperty(_STARTER$PROFESSIONAL, _Editions.PROFESSIONAL, (_PROFESSIONAL = {}, _defineProperty(_PROFESSIONAL, Hubs.HUB_MARKETING, MerchandiseIds.PRODUCT_MARKETING_PROFESSIONAL), _defineProperty(_PROFESSIONAL, Hubs.HUB_SALES, MerchandiseIds.PRODUCT_SALES_PROFESSIONAL), _defineProperty(_PROFESSIONAL, Hubs.HUB_SERVICE, MerchandiseIds.PRODUCT_SERVICE_PROFESSIONAL), _PROFESSIONAL)), _defineProperty(_STARTER$PROFESSIONAL, _Editions.ENTERPRISE, (_ENTERPRISE = {}, _defineProperty(_ENTERPRISE, Hubs.HUB_MARKETING, MerchandiseIds.PRODUCT_MARKETING_ENTERPRISE), _defineProperty(_ENTERPRISE, Hubs.HUB_SALES, MerchandiseIds.PRODUCT_SALES_ENTERPRISE), _defineProperty(_ENTERPRISE, Hubs.HUB_SERVICE, MerchandiseIds.PRODUCT_SERVICE_ENTERPRISE), _ENTERPRISE)), _STARTER$PROFESSIONAL);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/constants/SuiteEditionMerchIdMap.js
// module id = 107
// module chunks = 3 4 5